/**
 * Реестр type-плагинов `<plp-field>`. Здесь же определяется фолбэк
 * для неизвестных типов (рендер пустого input[type=text]).
 */

import type { FieldType } from './base.js';
import { textType } from './text.js';
import { emailType } from './email.js';
import { phoneType } from './phone.js';
import { textareaType } from './textarea.js';
import { selectType } from './select.js';
import { checkboxType } from './checkbox.js';
import { radioType } from './radio.js';
import { dateType } from './date.js';
import { hiddenType } from './hidden.js';

const REGISTRY: Record<string, FieldType> = {
  text: textType,
  email: emailType,
  phone: phoneType,
  textarea: textareaType,
  select: selectType,
  checkbox: checkboxType,
  radio: radioType,
  date: dateType,
  hidden: hiddenType,
};

export function getFieldType(type: string): FieldType {
  return REGISTRY[type] ?? textType;
}

export const KNOWN_TYPES = Object.keys(REGISTRY);
